/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createCampaign = /* GraphQL */ `
  mutation CreateCampaign(
    $input: CreateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    createCampaign(input: $input, condition: $condition) {
      id
      name
      advertiser
      contract_number
      start_time
      end_time
      deliveryDeadline
      duration
      languages
      notes
      scheduling_notes
      adminNotes
      type
      orderlineID
      sales_segment
      salesperson
      salesperson_contact
      mediaDeliveryPersonContacts
      sentTo
      status
      statusGroup
      automaticStatus
      owner
      ownerName
      collaborators
      viewers
      mediaAgencyID
      mediaAgency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      mediaCollaborators
      createdAt
      dummyType
      updatedAt
      agency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      assets {
        nextToken
        __typename
      }
      requiredResolutions {
        nextToken
        __typename
      }
      nativeResolutions {
        nextToken
        __typename
      }
      printSizes {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateCampaign = /* GraphQL */ `
  mutation UpdateCampaign(
    $input: UpdateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    updateCampaign(input: $input, condition: $condition) {
      id
      name
      advertiser
      contract_number
      start_time
      end_time
      deliveryDeadline
      duration
      languages
      notes
      scheduling_notes
      adminNotes
      type
      orderlineID
      sales_segment
      salesperson
      salesperson_contact
      mediaDeliveryPersonContacts
      sentTo
      status
      statusGroup
      automaticStatus
      owner
      ownerName
      collaborators
      viewers
      mediaAgencyID
      mediaAgency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      mediaCollaborators
      createdAt
      dummyType
      updatedAt
      agency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      assets {
        nextToken
        __typename
      }
      requiredResolutions {
        nextToken
        __typename
      }
      nativeResolutions {
        nextToken
        __typename
      }
      printSizes {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  mutation DeleteCampaign(
    $input: DeleteCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    deleteCampaign(input: $input, condition: $condition) {
      id
      name
      advertiser
      contract_number
      start_time
      end_time
      deliveryDeadline
      duration
      languages
      notes
      scheduling_notes
      adminNotes
      type
      orderlineID
      sales_segment
      salesperson
      salesperson_contact
      mediaDeliveryPersonContacts
      sentTo
      status
      automaticStatus
      owner
      ownerName
      collaborators
      viewers
      mediaAgencyID
      mediaAgency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      mediaCollaborators
      createdAt
      dummyType
      updatedAt
      agency {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      assets {
        nextToken
        __typename
      }
      requiredResolutions {
        nextToken
        __typename
      }
      nativeResolutions {
        nextToken
        __typename
      }
      printSizes {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
      enabled
      firstName
      lastName
      phoneNumber
      createdAt
      updatedAt
      userGroup
      owner
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      email
      enabled
      firstName
      lastName
      phoneNumber
      createdAt
      updatedAt
      userGroup
      owner
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      email
      enabled
      firstName
      lastName
      phoneNumber
      createdAt
      updatedAt
      userGroup
      owner
      __typename
    }
  }
`;
export const createApprover = /* GraphQL */ `
  mutation CreateApprover(
    $input: CreateApproverInput!
    $condition: ModelApproverConditionInput
  ) {
    createApprover(input: $input, condition: $condition) {
      id
      userID
      name
      email
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateApprover = /* GraphQL */ `
  mutation UpdateApprover(
    $input: UpdateApproverInput!
    $condition: ModelApproverConditionInput
  ) {
    updateApprover(input: $input, condition: $condition) {
      id
      userID
      name
      email
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteApprover = /* GraphQL */ `
  mutation DeleteApprover(
    $input: DeleteApproverInput!
    $condition: ModelApproverConditionInput
  ) {
    deleteApprover(input: $input, condition: $condition) {
      id
      userID
      name
      email
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createApproval = /* GraphQL */ `
  mutation CreateApproval(
    $input: CreateApprovalInput!
    $condition: ModelApprovalConditionInput
  ) {
    createApproval(input: $input, condition: $condition) {
      id
      approverID
      assetID
      campaignID
      campaignName
      startTime
      endTime
      status
      reason
      deadline
      createdAt
      updatedAt
      owner
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      asset {
        id
        name
        notes
        campaignID
        media
        thumbnail
        thumbnailComplete
        resolution
        metadata
        type
        fileSize
        duration
        dpi
        audio
        dynamicContent
        motiveMarker
        lowResolution
        framerate
        status
        start_time
        end_time
        week_days
        language
        language_confidence_score
        printServiceID
        sentToPrintServiceDate
        senderToPrintService
        startprint_sender
        digitalServiceSender
        digitalServiceDate
        digitalServiceNames
        api_files
        owner
        ownerName
        viewers
        mediaCollaborators
        createdAt
        updatedAt
        individualAssetIdsForMultiPagePDF
        dummyType
        __typename
      }
      __typename
    }
  }
`;
export const updateApproval = /* GraphQL */ `
  mutation UpdateApproval(
    $input: UpdateApprovalInput!
    $condition: ModelApprovalConditionInput
  ) {
    updateApproval(input: $input, condition: $condition) {
      id
      approverID
      assetID
      campaignID
      campaignName
      startTime
      endTime
      status
      reason
      deadline
      createdAt
      updatedAt
      owner
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      asset {
        id
        name
        notes
        campaignID
        media
        thumbnail
        thumbnailComplete
        resolution
        metadata
        type
        fileSize
        duration
        dpi
        audio
        dynamicContent
        motiveMarker
        lowResolution
        framerate
        status
        start_time
        end_time
        week_days
        language
        language_confidence_score
        printServiceID
        sentToPrintServiceDate
        senderToPrintService
        startprint_sender
        digitalServiceSender
        digitalServiceDate
        digitalServiceNames
        api_files
        owner
        ownerName
        viewers
        mediaCollaborators
        createdAt
        updatedAt
        individualAssetIdsForMultiPagePDF
        dummyType
        __typename
      }
      __typename
    }
  }
`;
export const deleteApproval = /* GraphQL */ `
  mutation DeleteApproval(
    $input: DeleteApprovalInput!
    $condition: ModelApprovalConditionInput
  ) {
    deleteApproval(input: $input, condition: $condition) {
      id
      approverID
      assetID
      campaignID
      campaignName
      startTime
      endTime
      status
      reason
      deadline
      createdAt
      updatedAt
      owner
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      asset {
        id
        name
        notes
        campaignID
        media
        thumbnail
        thumbnailComplete
        resolution
        metadata
        type
        fileSize
        duration
        dpi
        audio
        dynamicContent
        motiveMarker
        lowResolution
        framerate
        status
        start_time
        end_time
        week_days
        language
        language_confidence_score
        printServiceID
        sentToPrintServiceDate
        senderToPrintService
        startprint_sender
        digitalServiceSender
        digitalServiceDate
        digitalServiceNames
        api_files
        owner
        ownerName
        viewers
        mediaCollaborators
        createdAt
        updatedAt
        individualAssetIdsForMultiPagePDF
        dummyType
        __typename
      }
      __typename
    }
  }
`;
export const createAgency = /* GraphQL */ `
  mutation CreateAgency(
    $input: CreateAgencyInput!
    $condition: ModelAgencyConditionInput
  ) {
    createAgency(input: $input, condition: $condition) {
      id
      phone
      name
      email
      address
      postalNumber
      city
      country
      type
      contacts
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const updateAgency = /* GraphQL */ `
  mutation UpdateAgency(
    $input: UpdateAgencyInput!
    $condition: ModelAgencyConditionInput
  ) {
    updateAgency(input: $input, condition: $condition) {
      id
      phone
      name
      email
      address
      postalNumber
      city
      country
      type
      contacts
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const deleteAgency = /* GraphQL */ `
  mutation DeleteAgency(
    $input: DeleteAgencyInput!
    $condition: ModelAgencyConditionInput
  ) {
    deleteAgency(input: $input, condition: $condition) {
      id
      phone
      name
      email
      address
      postalNumber
      city
      country
      type
      contacts
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const createAsset = /* GraphQL */ `
  mutation CreateAsset(
    $input: CreateAssetInput!
    $condition: ModelAssetConditionInput
  ) {
    createAsset(input: $input, condition: $condition) {
      id
      name
      notes
      campaignID
      media
      thumbnail
      thumbnailComplete
      resolution
      metadata
      type
      fileSize
      duration
      dpi
      audio
      dynamicContent
      motiveMarker
      lowResolution
      framerate
      status
      start_time
      end_time
      week_days
      language
      language_confidence_score
      printServiceID
      sentToPrintServiceDate
      senderToPrintService
      startprint_sender
      digitalServiceSender
      digitalServiceDate
      digitalServiceNames
      api_files
      owner
      ownerName
      viewers
      mediaCollaborators
      createdAt
      updatedAt
      individualAssetIdsForMultiPagePDF
      dummyType
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      printService {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const updateAsset = /* GraphQL */ `
  mutation UpdateAsset(
    $input: UpdateAssetInput!
    $condition: ModelAssetConditionInput
  ) {
    updateAsset(input: $input, condition: $condition) {
      id
      name
      notes
      campaignID
      media
      thumbnail
      thumbnailComplete
      resolution
      metadata
      type
      fileSize
      duration
      dpi
      audio
      dynamicContent
      motiveMarker
      lowResolution
      framerate
      status
      start_time
      end_time
      week_days
      language
      language_confidence_score
      printServiceID
      sentToPrintServiceDate
      senderToPrintService
      startprint_sender
      digitalServiceSender
      digitalServiceDate
      digitalServiceNames
      api_files
      owner
      ownerName
      viewers
      mediaCollaborators
      createdAt
      updatedAt
      individualAssetIdsForMultiPagePDF
      dummyType
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      printService {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const deleteAsset = /* GraphQL */ `
  mutation DeleteAsset(
    $input: DeleteAssetInput!
    $condition: ModelAssetConditionInput
  ) {
    deleteAsset(input: $input, condition: $condition) {
      id
      name
      notes
      campaignID
      media
      thumbnail
      thumbnailComplete
      resolution
      metadata
      type
      fileSize
      duration
      dpi
      audio
      dynamicContent
      motiveMarker
      lowResolution
      framerate
      status
      start_time
      end_time
      week_days
      language
      language_confidence_score
      printServiceID
      sentToPrintServiceDate
      senderToPrintService
      startprint_sender
      digitalServiceSender
      digitalServiceDate
      digitalServiceNames
      api_files
      owner
      ownerName
      viewers
      mediaCollaborators
      createdAt
      updatedAt
      individualAssetIdsForMultiPagePDF
      dummyType
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      printService {
        id
        phone
        name
        email
        address
        postalNumber
        city
        country
        type
        contacts
        createdAt
        updatedAt
        owner
        __typename
      }
      __typename
    }
  }
`;
export const createCampaignRequiredResolution = /* GraphQL */ `
  mutation CreateCampaignRequiredResolution(
    $input: CreateCampaignRequiredResolutionInput!
    $condition: ModelCampaignRequiredResolutionConditionInput
  ) {
    createCampaignRequiredResolution(input: $input, condition: $condition) {
      id
      campaignID
      requiredResolutionID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      requiredResolution {
        id
        value
        type
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateCampaignRequiredResolution = /* GraphQL */ `
  mutation UpdateCampaignRequiredResolution(
    $input: UpdateCampaignRequiredResolutionInput!
    $condition: ModelCampaignRequiredResolutionConditionInput
  ) {
    updateCampaignRequiredResolution(input: $input, condition: $condition) {
      id
      campaignID
      requiredResolutionID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      requiredResolution {
        id
        value
        type
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteCampaignRequiredResolution = /* GraphQL */ `
  mutation DeleteCampaignRequiredResolution(
    $input: DeleteCampaignRequiredResolutionInput!
    $condition: ModelCampaignRequiredResolutionConditionInput
  ) {
    deleteCampaignRequiredResolution(input: $input, condition: $condition) {
      id
      campaignID
      requiredResolutionID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      requiredResolution {
        id
        value
        type
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createRequiredResolution = /* GraphQL */ `
  mutation CreateRequiredResolution(
    $input: CreateRequiredResolutionInput!
    $condition: ModelRequiredResolutionConditionInput
  ) {
    createRequiredResolution(input: $input, condition: $condition) {
      id
      value
      type
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      nativeResolutions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateRequiredResolution = /* GraphQL */ `
  mutation UpdateRequiredResolution(
    $input: UpdateRequiredResolutionInput!
    $condition: ModelRequiredResolutionConditionInput
  ) {
    updateRequiredResolution(input: $input, condition: $condition) {
      id
      value
      type
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      nativeResolutions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteRequiredResolution = /* GraphQL */ `
  mutation DeleteRequiredResolution(
    $input: DeleteRequiredResolutionInput!
    $condition: ModelRequiredResolutionConditionInput
  ) {
    deleteRequiredResolution(input: $input, condition: $condition) {
      id
      value
      type
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      nativeResolutions {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCampaignNativeResolution = /* GraphQL */ `
  mutation CreateCampaignNativeResolution(
    $input: CreateCampaignNativeResolutionInput!
    $condition: ModelCampaignNativeResolutionConditionInput
  ) {
    createCampaignNativeResolution(input: $input, condition: $condition) {
      id
      campaignID
      nativeResolutionID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      nativeResolution {
        id
        requiredResolutionID
        value
        type
        active
        verticalCut
        horizontalCut
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateCampaignNativeResolution = /* GraphQL */ `
  mutation UpdateCampaignNativeResolution(
    $input: UpdateCampaignNativeResolutionInput!
    $condition: ModelCampaignNativeResolutionConditionInput
  ) {
    updateCampaignNativeResolution(input: $input, condition: $condition) {
      id
      campaignID
      nativeResolutionID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      nativeResolution {
        id
        requiredResolutionID
        value
        type
        active
        verticalCut
        horizontalCut
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteCampaignNativeResolution = /* GraphQL */ `
  mutation DeleteCampaignNativeResolution(
    $input: DeleteCampaignNativeResolutionInput!
    $condition: ModelCampaignNativeResolutionConditionInput
  ) {
    deleteCampaignNativeResolution(input: $input, condition: $condition) {
      id
      campaignID
      nativeResolutionID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      nativeResolution {
        id
        requiredResolutionID
        value
        type
        active
        verticalCut
        horizontalCut
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createNativeResolution = /* GraphQL */ `
  mutation CreateNativeResolution(
    $input: CreateNativeResolutionInput!
    $condition: ModelNativeResolutionConditionInput
  ) {
    createNativeResolution(input: $input, condition: $condition) {
      id
      requiredResolutionID
      value
      type
      active
      verticalCut
      horizontalCut
      createdAt
      updatedAt
      requiredResolution {
        id
        value
        type
        createdAt
        updatedAt
        __typename
      }
      campaigns {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updateNativeResolution = /* GraphQL */ `
  mutation UpdateNativeResolution(
    $input: UpdateNativeResolutionInput!
    $condition: ModelNativeResolutionConditionInput
  ) {
    updateNativeResolution(input: $input, condition: $condition) {
      id
      requiredResolutionID
      value
      type
      active
      verticalCut
      horizontalCut
      createdAt
      updatedAt
      requiredResolution {
        id
        value
        type
        createdAt
        updatedAt
        __typename
      }
      campaigns {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deleteNativeResolution = /* GraphQL */ `
  mutation DeleteNativeResolution(
    $input: DeleteNativeResolutionInput!
    $condition: ModelNativeResolutionConditionInput
  ) {
    deleteNativeResolution(input: $input, condition: $condition) {
      id
      requiredResolutionID
      value
      type
      active
      verticalCut
      horizontalCut
      createdAt
      updatedAt
      requiredResolution {
        id
        value
        type
        createdAt
        updatedAt
        __typename
      }
      campaigns {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const createCampaignPrintSize = /* GraphQL */ `
  mutation CreateCampaignPrintSize(
    $input: CreateCampaignPrintSizeInput!
    $condition: ModelCampaignPrintSizeConditionInput
  ) {
    createCampaignPrintSize(input: $input, condition: $condition) {
      id
      campaignID
      printSizeID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      printSize {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const updateCampaignPrintSize = /* GraphQL */ `
  mutation UpdateCampaignPrintSize(
    $input: UpdateCampaignPrintSizeInput!
    $condition: ModelCampaignPrintSizeConditionInput
  ) {
    updateCampaignPrintSize(input: $input, condition: $condition) {
      id
      campaignID
      printSizeID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      printSize {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const deleteCampaignPrintSize = /* GraphQL */ `
  mutation DeleteCampaignPrintSize(
    $input: DeleteCampaignPrintSizeInput!
    $condition: ModelCampaignPrintSizeConditionInput
  ) {
    deleteCampaignPrintSize(input: $input, condition: $condition) {
      id
      campaignID
      printSizeID
      createdAt
      updatedAt
      campaign {
        id
        name
        advertiser
        contract_number
        start_time
        end_time
        deliveryDeadline
        duration
        languages
        notes
        scheduling_notes
        adminNotes
        type
        orderlineID
        sales_segment        
        salesperson
        salesperson_contact
        mediaDeliveryPersonContacts
        sentTo
        status
        automaticStatus
        owner
        ownerName
        collaborators
        viewers
        mediaAgencyID
        mediaCollaborators
        createdAt
        dummyType
        updatedAt
        __typename
      }
      printSize {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const createPrintSize = /* GraphQL */ `
  mutation CreatePrintSize(
    $input: CreatePrintSizeInput!
    $condition: ModelPrintSizeConditionInput
  ) {
    createPrintSize(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const updatePrintSize = /* GraphQL */ `
  mutation UpdatePrintSize(
    $input: UpdatePrintSizeInput!
    $condition: ModelPrintSizeConditionInput
  ) {
    updatePrintSize(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
export const deletePrintSize = /* GraphQL */ `
  mutation DeletePrintSize(
    $input: DeletePrintSizeInput!
    $condition: ModelPrintSizeConditionInput
  ) {
    deletePrintSize(input: $input, condition: $condition) {
      id
      name
      createdAt
      updatedAt
      campaigns {
        nextToken
        __typename
      }
      __typename
    }
  }
`;
